import React, { FC, ReactNode } from 'react'

export const getFlightLogo = (airlineCode: string): string => {
    if (!airlineCode) return 'https://ui.cltp.co/images/logos/air-logos/DEFAULT_2x.png'

    // Special case for 3L airline code
    const code = airlineCode === '3L' ? 'G9' : airlineCode
    return `https://ui.cltp.co/images/logos/air-logos/svg_logos/${code}.svg`
}

export interface AirlineLogoProps {
    airlineCode: string
    className?: string
    width?: number
    height?: number
}

export const AirlineLogo: FC<AirlineLogoProps> = ({ airlineCode, className = '', width = 24, height = 24 }) => {
    const logoUrl = getFlightLogo(airlineCode)

    const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        const target = e.target as HTMLImageElement
        if (target.src !== 'https://ui.cltp.co/images/logos/air-logos/DEFAULT_2x.png') {
            target.src = 'https://ui.cltp.co/images/logos/air-logos/DEFAULT_2x.png'
        }
    }

    return (
        <img
            src={logoUrl}
            alt={airlineCode}
            width={width}
            height={height}
            className={className}
            onError={handleError}
            style={{
                filter: 'inherit'
            }}
        />
    )
}

export const getAirlineIcons = (airlineCodes: string[] = [], width = 24, height = 24): ReactNode => {
    if (!airlineCodes.length) return null

    // For single airline or first segment
    if (airlineCodes.length === 1) {
        return <AirlineLogo airlineCode={airlineCodes[0]} width={width} height={height} />
    }

    // For multiple airlines, show unique airline logos
    const uniqueAirlines = airlineCodes.reduce<{ codes: string[]; nodes: ReactNode[] }>(
        (acc, airlineCode, index) => {
            if (!airlineCode || acc.codes.includes(airlineCode)) {
                return acc
            }
            acc.codes.push(airlineCode)
            acc.nodes.push(
                <AirlineLogo key={`${airlineCode}-${index}`} airlineCode={airlineCode} width={width} height={height} />
            )
            return acc
        },
        { codes: [], nodes: [] }
    )

    return <>{uniqueAirlines.nodes}</>
}

// getFlightLogoUrl
